import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { MyAuthService } from "../../authentication/auth.service";
import { SharedService } from "../../services/shared.service";
import { ApiService } from "../../services/api.service";

@Component({
  selector: "app-mobile-verify-form",
  templateUrl: "./mobile-verify-form.component.html",
  styleUrls: ["./mobile-verify.component.scss"]
})
export class MobileVerifyFormComponent implements OnInit {
  public userInfo: any;
  public show = false;
  public countryCodes: any;
  public dialCode = "+91";
  public verifyMobileForm: FormGroup;
  public verifyOtpForm: FormGroup;
  public invalidmobile = false;
  public isSubmitted = false;
  public isotpSubmitted = false;
  public verifyOtpError = "";
  public successMsg = "Your Mobile number is verified successfully!";
  constructor(
    public formBuilder: FormBuilder,
    private _auth: MyAuthService,
    private _shared: SharedService,
    private _api: ApiService
  ) {
    this._auth.userData.subscribe(userInfo => {
      this.userInfo = userInfo;
    });
  }

  ngOnInit() {
    this.getcountryCodes();
    if (this.userInfo && this.userInfo.identity.mobile === "") {
      console.log(this.userInfo.identity.mobile);
      console.log("Mobile Blank");
    } else {
      console.log(this.userInfo);
      console.log("Mobile", this.userInfo);
    }
    this.verifyMobileForm = this.formBuilder.group({
      mobile: ["", [Validators.required]]
    });
  }
  get formControls() {
    return this.verifyMobileForm.controls;
  }
  get formControls1() {
    return this.verifyOtpForm.controls;
  }

  sendOtp() {
    console.log("Verify", this.dialCode);
    console.log("ISVALID", this.verifyMobileForm.valid);
    if (this.verifyMobileForm.valid) {
      this.invalidmobile = false;
      this._api
        .sendOTP({ number: this.dialCode + this.verifyMobileForm.value.mobile })
        .subscribe(
          result => {
            if (result.responseType === "success") {
              this.createOtpForm();
              this.isSubmitted = true;
              this.verifyMobileForm.reset();
            } else {
              this.invalidmobile = true;
            }
          },
          err => {
            this.isSubmitted = false;
          }
        );
    } else {
      this.invalidmobile = true;
      // this.isSubmitted = true;
    }
  }

  createOtpForm() {
    this.verifyOtpForm = this.formBuilder.group({
      number: [this.verifyMobileForm.value.mobile, [Validators.required]],
      otp: ["", [Validators.required]]
    });
  }
  resendOtp() {
    this._api.sendOTP({ number: this.verifyOtpForm.value.number }).subscribe(
      result => {
        if (result.responseType === "success") {
          this.createOtpForm();
          this.isSubmitted = true;
        }
      },
      err => {
        this.isSubmitted = false;
      }
    );
  }

  verifyOTP() {
    console.log("Submit OPT");
    if (this.verifyOtpForm.valid) {
      this.verifyOtpError = "";
      this._api
        .verifyOTP({
          number: this.dialCode + this.verifyOtpForm.value.number,
          otp: this.verifyOtpForm.value.otp
        })
        .subscribe(
          result => {
            if (result.responseType === "success") {
              this.userInfo.identity.mobile =
                this.dialCode + this.verifyOtpForm.value.number;
              this.verifyOtpForm.reset();
              this.isotpSubmitted = true;
              //console.log(this.userInfo);
              this._auth.updateUserInfo(this.userInfo);
            } else {
              this.verifyOtpError = result.message;
              this.isotpSubmitted = false;
            }
          },
          err => {
            this.isotpSubmitted = false;
          }
        );
    }
  }

  close() {
    this._shared.toggleMobileVerify(null);
  }

  getcountryCodes() {
    this._api.getcountryCodes().subscribe(
      res => {
        this.countryCodes = res;
      },
      err => {
        console.log(err);
      }
    );
  }
}
